export type ApiResponseType = 'json' | 'blob' | 'text';